import { newPageInfo, PageInfo } from "@hex-insights/router";
import { Employee } from "../../../../Utilities";

export type DetailViewSubPageInfo = PageInfo<string, (id: Employee["id"]) => string, { employeeID: Employee["id"] }>;

export type DetailViewSubPageInfos = {
	overview: DetailViewSubPageInfo;
	academics: DetailViewSubPageInfo;
};

export function newOverviewPageInfo(
	parent: PageInfo<any, (id: Employee["id"]) => string, { employeeID: Employee["id"] }>,
) {
	return newPageInfo({
		name: "Employee Detail Overview",
		title: "",
		description: "Overview page of the Employee.",
		exact: true,
		to: parent.to,
		path: parent.path,
		parent: parent,
		paramsType: parent.paramsType,
	});
}

export function newAcademicsPageInfo(
	parent: PageInfo<any, (id: Employee["id"]) => string, { employeeID: Employee["id"] }>,
) {
	return newPageInfo({
		title: "Academics",
		description: "Academic information for the Employee.",
		exact: true,
		to: (id: Employee["id"]) => parent.to(id) + "/academics",
		path: parent.path + "/academics",
		parent: parent,
		paramsType: parent.paramsType,
	});
}
